import React, { useState, useEffect } from "react";
import Modal from "../../common/Modal/Modal";
import "./AssignPropertiesModal.css";

/**
 * Modal that pops up on click of a row on members page, 
 * so the the user can select the properties that 
 * they desire to send to the user. 
 */

export default function AssignPropertiesModal({
  selectedMember,
  closeModal,
  selectedProperties,
  onPropertyChange,
  allMembers,
}) {
  const propertyData =
    JSON.parse(localStorage.getItem("UpdatedDataArray")) || [];
  const [toggleState, setToggleState] = useState("");
  const [searchProperty, setSearchProperty] = useState("");
  const [categories, setCategories] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [checkedProperties, setCheckedProperties] =
    useState(selectedProperties);
  const [countCheckedProperties, setCountCheckedProperties] = useState(0);

  //The following variables are necessary for RepX files
  let snapshotName = localStorage.getItem("selectedSnapshot");
  let isRepXFile = snapshotName.toLowerCase().includes("repx");

  // Function to generate categories
  const generateCategories = () => {
    const categoryToPropertiesMap = propertyData.reduce((acc, item) => {
      const category = item["Category (per property)"].trim().toUpperCase();
      const property = item["Property"].trim().toUpperCase();

      if (category && property) {
        acc[category] = acc[category] || new Set();
        acc[category].add(property);
      }

      return acc;
    }, {});

    const allCategories = Object.keys(categoryToPropertiesMap);
    setCategories(allCategories);

    if (allCategories.length > 0) {
      setToggleState(allCategories[0]);
    }
  };

  // Generate categories on mount
  useEffect(() => {
    generateCategories();
  }, []);

  // Update filtered data based on the active tab and search term
  useEffect(() => {
    const fetchedData = propertyData.filter((item) => {
      const property = item["Property"].toUpperCase();
      //These properties should not be shown as clients shouldn't be able to edit them
      const isExcludedProperty =
        isRepXFile &&
        (property === "SNAPSHOT_LOCATION" ||
          property === "SNAPSHOT_NAME" ||
          property === "DATA_LOC");
      return (
        item["Category (per property)"].toUpperCase() === toggleState &&
        property.includes(searchProperty.toUpperCase()) &&
        !isExcludedProperty
      );
    });

    setFilterData(fetchedData);
  }, [toggleState, searchProperty]);

  // Update count of checked properties
  useEffect(() => {
    const count = checkedProperties.length;
    setCountCheckedProperties(count);
  }, [checkedProperties]);

  const handleCheckboxChange = (propertyName) => {
    setCheckedProperties((currentCheckedProperties) => {
      const newCheckedProperties = currentCheckedProperties.includes(
        propertyName
      )
        ? currentCheckedProperties.filter((name) => name !== propertyName)
        : [...currentCheckedProperties, propertyName];
      return newCheckedProperties;
    });
  };

  const handleDoneButtonClick = () => {
    onPropertyChange(checkedProperties);
    closeModal();
  };

  return (
    <div className="assign-properties-cnt">
      <Modal
        isOpen={true}
        onClose={closeModal}
        title={
          <div className="assign-properties-header">
            <div className="assign-modal-title">Assign properties:</div>
            <span>{selectedMember} </span>

            <div className="assign-properties-select-search-cnt">
              <div className="assign-properties-select-cnt">
                <select
                  value={toggleState}
                  onChange={(e) => setToggleState(e.target.value)}
                >
                  {categories.map((category) => (
                    <option key={category} value={category}>
                      {category}
                    </option>
                  ))}
                </select>
              </div>
              <input
                className="assign-properties-search"
                type="text"
                placeholder="Search property"
                value={searchProperty}
                onChange={(e) => setSearchProperty(e.target.value)}
              />
            </div>
          </div>
        }
        showCustomContent={true}
        customContent={
          <div>
            <div className="container">
              <div className="assigned-property-cnt">
                {filterData.map((property, index) => (
                  <label className="assigned-property-label" key={index}>
                    <input
                      type="checkbox"
                      checked={checkedProperties.includes(property["Property"])}
                      onChange={() =>
                        handleCheckboxChange(property["Property"])
                      }
                    />
                    <div className="label-property">{property["Property"]}</div>
                  </label>
                ))}
              </div>

              <div className="assign-properties-close-button-cnt">
                <button
                  className="green-button"
                  onClick={handleDoneButtonClick}
                >
                  Done ({countCheckedProperties})
                </button>
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
}
